export enum EmailTemplateTypes {
  FreeFormatText = 0,
  PropertyBulletinMatchedProperties = 1,
  PropertyDetails = 2,
  DevelopmentDetails = 3,
  PropertyBulletinAllProperties = 4,
  PropertyDetailsFreeFormat = 5,
  NewsLetter = 6,
  PropertyFeebackRequest = 7,
}
